const LeagueAlltimePageReducer = (state, action) => {
  switch (action.type) {
    case 'LEAGUE_ALLTIME_META_LEAGUE_UPDATE':
      return {...state, league: action.data};
    case 'LEAGUE_ALLTIME_FETCHING':
      return {...state, isFetching: true};
    case 'LEAGUE_ALLTIME_UPDATE':
      return {...state, teams: action.data, isFetching: false};
    default:
      return state;
  }
};

export {LeagueAlltimePageReducer};
